import { Component, computed, input } from '@angular/core';
import { GlossaryEntryComponent } from "../glossary-entry/glossary-entry.component";
import type { GlossaryGroup } from '../../interfaces/glossaryInterface';
import { AccordionItemComponent } from "../../components/accordion/accordion-item/accordion-item.component";

@Component({
    selector: 'app-glossary-group',
    imports: [GlossaryEntryComponent, AccordionItemComponent],
    templateUrl: './glossary-group.component.html',
    styleUrl: './glossary-group.component.scss'
})
export class GlossaryGroupComponent {
  group = input.required<GlossaryGroup>();
  protected name = computed(() => this.group().name);
}
